/*
 * @Author: Roger Wei 
 * @Date: 2022-01-24 11:09:29 
 * @Last Modified by: Roger Wei
 * @Last Modified time: 2022-02-20 12:20:06
 */

<template>
  <el-dialog v-dialogDrag :title="config.isReadOnly ? '查看检测数据' : '检测录入'" :visible.sync="visible" width="1180px"
    :close-on-click-modal="false" @close="onClose" @open="onOpen">
    <el-form inline class="demo-form-inline" label-width="120px">
      <el-form-item label="供应商：">{{ config.supplierName }}</el-form-item>
      <el-form-item label="原物料：">{{ config.rawName }}</el-form-item>
      <el-form-item label="车牌号：">{{ config.carNo }}</el-form-item>
      <el-form-item>
        <span slot="label" style="color: red">库存仓：</span>
        <el-select ref="warehouseId" v-model="config.warehouseId" filterable style="width: 170px" placeholder="请选择"
          :disabled="config.isReadOnly" @change="
            $nextTick(() => {
              config.warehouseName = $refs.warehouseId.selectedLabel;
            })
            ">
          <el-option v-for="(item, index) in warehouseList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="whertherAggregate == 1">
        <span slot="label" style="color: red">含水率：</span>
        <el-input v-model="config.moistureContent" type="number" style="width: 170px" placeholder="请输入"
          :disabled="config.isReadOnly"> </el-input>
      </el-form-item>
      <el-form-item v-if="!hidden" label="试验人：">
        <el-select v-model="tester" filterable value-key="value" placeholder="请选择" :disabled="config.isReadOnly">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="!hidden" label="审核人：">{{ approver }}</el-form-item>
      <h4>检验项目</h4>
      <el-form-item v-for="(item, key) in formData" :key="key" :label="item.title + '：'">
        <div :class="item.text ? 'text' : ''">
          <div v-if="item.type === 2">
            <!--  :disabled="config.isReadOnly || isChange" -->
            <el-input v-model="item.resultValue" v-input-limit="item.limit || /''/" type="number" :class="item.clsObj"
              :style="item.style" placeholder="请输入"> </el-input>
            <el-tooltip v-if="config.isReadOnly && item.exceed" class="item" effect="dark" placement="right">
              <div slot="content">{{ item.exceed }}</div>
              <i class="el-icon-s-flag"></i>
            </el-tooltip>
          </div>
          <div v-else-if="item.type === 1">
            <!-- :disabled="config.isReadOnly || isChange" -->
            <el-select v-model="item.resultValue" clearable placeholder="请选择" value-key="id" :class="item.clsObj">
              <el-option v-for="t in item.list" :key="t.id" :label="t.value" :value="t"></el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
    </el-form>

    <!-- <el-table :data="formData" border style="width: 100%" header-align="center">
            <el-table-column prop="title" label="检验项目" align="center"></el-table-column>
            <el-table-column prop="" label="检测值" align="center">
                <template slot-scope="{row}">
                    <div v-if="row.type === 1">
                        <el-select v-model="row.resultValue" clearable placeholder="请选择" :disabled="config.isReadOnly">
                            <el-option v-for="item in row.options" :key="item.id" :label="item.value" :value="item.id"></el-option>
                        </el-select>
                    </div>
                    <div v-if="row.type === 2">
                        <el-input v-model="row.resultValue" clearable style="width: 215px;" placeholder="请输入" :disabled="config.isReadOnly" />
                    </div>
                </template>
            </el-table-column>
        </el-table> -->

    <div v-if="!hidden" class="remark">
      <div class="name">备注：</div>
      <div class="input">
        <el-input v-model="remark" type="textarea" :rows="3" placeholder="请输入内容"
          :disabled="config.isReadOnly || isChange" />
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="onClose">{{ config.isReadOnly ? "关 闭" : "取 消" }}</el-button>
      <span v-if="!config.isReadOnly">
        <el-button v-if="!isChange" class="bottom_all" type="primary" @click="onConfirm">保 存</el-button>
        <el-button v-if="isChange" class="bottom_all" type="primary" @click="onConfirmUpdate">确 定</el-button></span>
    </span>
  </el-dialog>
</template>

<script>
import { getUsetListByPermission, getDetailTesItems, getDetail, countResult, saveResul, updateResult, queryWarehouseByStation } from "@/api/index.js";
import { getUserInfo } from "@/utils/auth.js";

export default {
  props: {
    config: {
      type: Object,
      default: () => { },
    },
    visible: {
      type: Boolean,
      default: true,
    },
    isChange: {
      type: Boolean,
      default: false,
    },
    checkOutData: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      hidden: true,
      tester: {}, // 试验人（对象 id name）
      options: [], // 试验人下拉项
      approver: "", // 审核人
      approverId: "", // 审核人id
      tableData: [], // 检验项目
      remark: "", // 备注
      formData: {}, // 检验数据
      warehouseList: [],
      whertherAggregate: 0,
      detailId: "",
    };
  },
  methods: {
    async onOpen() {
      let userInfo = await getUserInfo();

      // 获取试验者下拉列表数据 function(res)
      getUsetListByPermission().then(res => {
        if (res.code === 1001) {
          this.options = res.data.map(item => ({
            value: item.id,
            label: item.name,
          }));
          // console.log(userInfo, res.data, this.options)
          if (
            res.data.find(item => {
              return item.id === userInfo.userId;
            })
          ) {
            // // 设置默认试验者为登录人
            this.tester = {
              value: userInfo.userId,
              label: userInfo.userRealName,
            };
          }
        }
      });
      //获取库存仓数据
      queryWarehouseByStation({ stationId: this.checkOutData.stationId, rawNameId: this.checkOutData.rawId }).then(res => {
        if (res.code == 1001) {
          this.warehouseList = res.data;
        }
      });

      if (this.config) {
        console.log(this.config);
        // 获取保存过的数据
        getDetail({ pid: this.config.id }).then(res => {
          if (res.code === 1001) {
            if (res.data) {
              this.detailId = res.data.id;
              this.approver = res.data.approver;
              this.approverId = res.data.approverId;
              this.whertherAggregate = res.data.whertherAggregate;
              this.$set(this.config, "warehouseId", res.data.warehouseId || "");
              this.$set(this.config, "warehouseName", res.data.warehouseName || "");
              this.$set(this.config, "moistureContent", res.data.moistureContent || "");
              this.parseContent(res.data.content);
              // this.formData = JSON.parse(res.data.content)
              // if(res.data.content) {
              //     this.tableData = Object.values(JSON.parse(res.data.content)).map(item=>{
              //         // console.log(item)
              //         return {
              //             ...item,
              //             options: item.options ? JSON.parse(item.options) : [],
              //             resultValue: item.type === 1 ? item.resultValue.id : item.resultValue
              //         }
              //     })
              // }
            } else {
              this.getDefaultCheckItem();
            }
          }
        });
      } else {
        this.getDefaultCheckItem();
      }
    },
    getDefaultCheckItem() {
      // 获取检验数据
      getDetailTesItems({ id: this.config.id }).then(res => {
        if (res.code === 1001) {
          this.approver = res.data.approver;
          this.approverId = res.data.approverId;
          this.whertherAggregate = res.data.whertherAggregate;
          this.$set(this.config, "warehouseId", res.data.warehouseId || "");
          this.$set(this.config, "warehouseName", res.data.warehouseName || "");
          this.$set(this.config, "moistureContent", res.data.moistureContent || "");
          this.parseContent(res.data.content, true);
          // if(res.data.content) {
          //     this.tableData = Object.values(JSON.parse(res.data.content)).map(item=>({
          //         ...item,
          //         options: item.options ? JSON.parse(item.options) : [],
          //         resultValue: item.type === 1 ? JSON.parse(item.condition).id : ''
          //     }))
          // }

          // console.log(this.formData)
        }
      });
    },
    parseContent(content, def = false) {
      function fixJsonString(str) {
        return str
          .replace(/\\/g, '')    // 移除所有反斜杠 \
          .replace(/"\[/g, '[')  // 替换 "[ 为 [
          .replace(/\]"/g, ']')  // 替换 ]" 为 ]
          .replace(/"\{/g, '{')  // 替换 "{ 为 {
          .replace(/\}"/g, '}'); // 替换 }" 为 }
      }
      let dataObj = ""
      try {
    dataObj = JSON.parse(content);
  } catch (error) {
    console.error('JSON 解析失败:', error);
    let str1 = fixJsonString(content)
         dataObj = JSON.parse(str1)
  }

      
      for (let key in dataObj) {
        let item = dataObj[key];
        if (item.title == "含水率" && this.whertherAggregate == 1) {
          delete dataObj[key];
        }
        if (item.type === 1 && item.options) {
          if (typeof item.options === "string") {
            item.list = JSON.parse(item.options);
          } else {
            item.list = item.options
          }
          if (item.resultValue != undefined && item.resultValue != null) {
            if (item.resultValue.length === 0) {
              item.resultValue = null;
            } else if (typeof item.resultValue === "string") {
              item.resultValue = JSON.parse(item.resultValue);
            }
          }
          //快检选项默认设置合格值
          if (def) {
            item.resultValue = JSON.parse(item.condition);
          }
        }

        item.clsObj = {};
        if (this.config.isReadOnly) {
          // 标记不同颜色
          if (item.isQualified === 0) {
            item.clsObj["red-bg"] = true;
          } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
            item.clsObj["yellow-bg"] = true;
          }
        }
      }
      this.formData = dataObj;
    },
    onClose() {
      this.$emit("update:visible", false);
    },
    onConfirmUpdate() {
      if (!this.config.warehouseId) {
        this.$message.warning("库存仓不能为空!");
        return;
      }
      if (this.whertherAggregate == 1 && !this.config.moistureContent) {
        this.$message.warning("含水率不能为空!");
        return;
      }
      let params = {
        id: this.config.id,
        moistureContent: this.config.moistureContent,
        warehouseName: this.config.warehouseName,
        warehouseId: this.config.warehouseId,
      };
      updateResult(params).then(res => {
        if (res.code == 1001) {
          if (!res.data) {
            this.$message.success("保存成功");
          } else {
            this.$message.success(res.data);
          }

          this.onClose();
          this.$emit("updated", false);
        }
      });
    },
    onConfirm() {
      if (!this.tester && !this.hidden) return this.$message.info("请选择试验人");
      // 校验数据完整性（至少录入一条数据）
      let num = 0;
      if (!this.config.warehouseId) {
        this.$message.warning("库存仓不能为空!");
        return;
      }
      if (this.whertherAggregate == 1 && !this.config.moistureContent) {
        this.$message.warning("含水率不能为空!");
        return;
      }
      if (this.formData) {
        for (let key in this.formData) {
          let item = this.formData[key];
          if (item.type === 1) {
            if (!!item.resultValue && item.resultValue.id !== undefined) {
              num++;
            }
          } else if (item.type === 2) {
            if (item.resultValue !== undefined && item.resultValue.length > 0) {
              num++;
            }
          }
        }
        if (num === 0) {
          return this.$message.warning("请至少录入一项数据");
        }
        // 获取提交检验的数据
        let data = JSON.parse(JSON.stringify(this.formData));
        for (let key in data) {
          let item = data[key];
          if (item && item.type === 1) {
            item.resultValue = JSON.stringify(item.resultValue);
          }
        }
        // for (let i = 0; i < this.tableData.length; i++) {
        //     for (const key in this.formData) {
        //         if(this.tableData[i].title === this.formData[key].title) {
        //             let val = this.tableData[i].resultValue
        //             if (this.tableData[i].type === 1) {
        //                 val = this.tableData[i].options.find(item => {return item.id == val})
        //             }
        //             this.formData[key].resultValue = val
        //         }
        //     }
        // }
        console.log(JSON.stringify(data))
        countResult({ pid: this.config.id, content: JSON.stringify(data), type: 1 }).then(res => {
          if (res.code === 1001) {
            const result = res.data.notQualified ? "NG" : "OK";
            const h = this.$createElement;
            console.log(res.data.resultStatus & 1, res.data.resultStatus);
            this.$msgbox({
              title: "结果判断",
              message: h("div", null, [
                h("p", null, [h("span", null, "系统检测结果："), h("span", { style: `color: ${result === "OK" ? "green" : "#cc3300"}` }, result)]),
                h("p", { style: `display: ${(res.data.resultStatus & 1) === 1 ? "block" : "none"}` }, "本次检验数据满足异常标准，需要进行审核"),
              ]),
              showCancelButton: true,
              confirmButtonText: (res.data.resultStatus & 1) === 1 ? "进入审核" : "保 存",
              cancelButtonText: "取消",
            }).then(action => {
              if (action === "confirm") {
                const params = {
                  pid: this.config.id,
                  handling: "",
                  imgs: "",
                  outcome: result,
                  qualified: res.data.notQualified,
                  remark: this.remark,
                  adjacent: res.data.adjacent,
                  detectionValue: {
                    ...res.data,
                    approver: this.approver,
                    approverId: this.approverId,
                    inspector: this.tester.label,
                    inspectorId: this.tester.value,
                    type: 1, // 快检
                    pid: this.config.id,
                    consignmentId: this.config.consignmentId,
                    content: res.data.content,
                    moistureContent: this.config.moistureContent,
                    warehouseName: this.config.warehouseName,
                    warehouseId: this.config.warehouseId,
                  },
                };
                if ((res.data.resultStatus & 1) === 0) {
                  // 保存
                  saveResul(params).then(res => {
                    if (res && res.code === 1001) {
                      if (!res.data) {
                        this.$message.success("保存成功");
                      } else {
                        this.$message.success(res.data);
                      }
                      this.onClose();
                      this.$emit("updated", false);
                    }
                  });
                } else {
                  // 审核
                  const query = {
                    ...params,
                    detectionValue: JSON.stringify(params.detectionValue),
                    ...this.checkOutData,
                    outcome: result,
                    tableDataSource: JSON.stringify(res.data.anomalyCriteriaJson),
                  };
                  this.$emit("check", query);
                  this.$emit("update:visible", false);
                  this.$emit("updated", false);
                }
              } else {
                console.log("cancel");
              }
            });
          }
        });
      } else {
        const params2 = {
          pid: this.config.id,
          handling: "",
          imgs: "",
          outcome: "OK",
          qualified: "",
          remark: this.remark,
          adjacent: "",
          detectionValue: {
            resultStatus: 0,
            approver: this.approver,
            approverId: this.approverId,
            inspector: this.tester.label,
            inspectorId: this.tester.value,
            type: 1, // 快检
            pid: this.config.id,
            consignmentId: this.config.consignmentId,
            content: "",
            moistureContent: this.config.moistureContent,
            warehouseName: this.config.warehouseName,
            warehouseId: this.config.warehouseId,
          },
        };
        saveResul(params2).then(res => {
          if (res && res.code === 1001) {
            if (!res.data) {
              this.$message.success("保存成功");
            } else {
              this.$message.success(res.data);
            }
            this.onClose();
            this.$emit("updated", false);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-form-inline {
  .el-form-item {
    margin-right: 0;
    width: 33%;
  }
}

.remark {
  display: flex;
  margin-top: 20px;

  .name {
    width: 60px;
    text-align: right;
  }

  .input {
    flex: 1;
  }
}

.red-bg {
  background: red;
  color: #000;
}

.yellow-bg {
  background: #ffffcd;
  color: #000;
  cursor: pointer;
}

.el-icon-s-flag {
  float: right;
  color: #f56c6c;
  display: inline-block;
  position: relative;
  top: -25px;
  right: -20px;
}
</style>





